(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/serversidehelper/assets/javascripts/handlebarshelpers.js') >= 0) return;  svs.modules.push('/components/app/serversidehelper/assets/javascripts/handlebarshelpers.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


(function () {
  'use strict';

  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    var trinidad = require('trinidad-core').core; 


    registerHelpers(require('hbs'), trinidad.components.require('libs', 'moment').moment, require('underscore'));
  } else {
    registerHelpers(Handlebars, moment, _);
  }

  function registerHelpers(hbs, moment, _) {
    hbs.registerHelper('moduleTemplateBase', function (templateBase, context) {
      var templateSrc;

      if (typeof templateBase === 'string') {
        templateSrc = templateBase;
      } else {
        templateSrc = "svs-".concat(context.data.root.modulePath);
      }

      return "".concat(templateSrc, "-");
    });
    hbs.registerHelper('none', function () {
      var params = Array.prototype.slice.call( 
      arguments, 0, arguments.length - 1); 

      var options = arguments[arguments.length - 1];
      var i = params.length;

      while (i--) {
        if (params[i]) {
          return options && typeof options.inverse === 'function' ? options.inverse(this) : false;
        }
      }

      return options && typeof options.fn === 'function' ? options.fn(this) : true;
    });
    hbs.registerHelper('all', function () {
      var params = Array.prototype.slice.call( 
      arguments, 0, arguments.length - 1); 

      var options = arguments[arguments.length - 1];
      var i = params.length;

      while (i--) {
        if (!params[i]) {
          return options && typeof options.inverse === 'function' ? options.inverse(this) : false;
        }
      }

      return options && typeof options.fn === 'function' ? options.fn(this) : true;
    });
    hbs.registerHelper('attributes', function (options) {
      var attributeString = '',
          attributeName;

      for (attributeName in options.hash) {
        if (Object.prototype.hasOwnProperty.call(options.hash, attributeName)) {
          attributeString += "".concat(attributeName, "=\"").concat(options.hash[attributeName], "\" ");
        }
      }

      return attributeString;
    }); 

    hbs.registerHelper('getContext', function (model) {
      return model instanceof Array && !model.length && {} || model || {};
    });
    hbs.registerHelper('nestedModel', function () {
      var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return model.attributes || model;
    });
    hbs.registerHelper('conditional', function () {
      if (arguments[0]) {
        return arguments[1];
      }

      return arguments[2];
    }); 

    hbs.registerHelper('usePartialIfExists', function (partial, context, options) {
      var res;

      if (typeof partial === 'function') {
        res = partial(context, options);
      } 


      if (res && res.length > 0) {
        return res;
      }

      return options.fn(this);
    });
    hbs.registerHelper('isEmpty', function () {
      var params = Array.prototype.slice.call(arguments, 0, arguments.length - 1);
      var options = arguments[arguments.length - 1];
      var i = params.length;

      while (i--) {
        if (params[i] && typeof params[i].size === 'function' ? params[i].size() : !_.isEmpty(params[i])) {
          return options && typeof options.inverse === 'function' ? options.inverse(this) : false;
        }
      }

      return options && typeof options.fn === 'function' ? options.fn(this) : true;
    });
  }
})();
 })(window);